module.exports = __webpack_public_path__ + "media/icons/cena_not_transparent@3x-e97273ae.svg";